// Bildfonster i produktgalleriet pa datorn.
//
// Gridden visar bara ett utsnitt av bilderna - fyra eller atta - och under den
// ligger en rad med alla. Klickar man pa en miniatyr blir den bilden den forsta
// i gridden och fonstret skjuts framat.
//
// Liquid renderar bade raden och utgangslaget (bild 0 och framat), sa sidan ar
// ratt redan innan den har filen har kort. Harifran andras bara vilket utsnitt
// som visas.
//
// Ingen state i en modul: <media-gallery> byts ut helt av media-gallery.js vid
// varje variantbyte, och da skulle en referens hit peka pa borttagna noder.
// Darfor laser vi laget ur DOM:en varje gang och lyssnar pa document.
(function () {
  if (window.bozettoGalleriFonster) return;
  window.bozettoGalleriFonster = true;

  // Gridden ar dold under 750 px - samma brytpunkt som temats egen CSS.
  function paDatorn() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function galleriFor(element) {
    var rot = element.closest('media-gallery');
    if (!rot) return null;

    var grid = rot.querySelector('.media-gallery__grid[data-bz-fonster]');
    var rad = rot.querySelector('[data-bz-miniatyrer]');
    if (!grid || !rad) return null;

    var antal = parseInt(grid.getAttribute('data-bz-fonster'), 10);
    if (!(antal > 0)) return null;

    return {
      bilder: Array.prototype.slice.call(grid.querySelectorAll('[data-bz-i]')),
      miniatyrer: Array.prototype.slice.call(rad.querySelectorAll('[data-bz-till]')),
      antal: antal,
    };
  }

  function visa(g, vald) {
    // Fonstret far aldrig ga utanfor listan. Narmar vi oss slutet backar det
    // tillbaka sa gridden alltid ar full - en halvtom grid ser trasig ut.
    //
    // Darfor ar "vald" och "fonstrets borjan" inte samma sak sista biten: klickar
    // man pa nast sista bilden kan den inte bli forst, men den ar anda den man
    // valde och ska vara markerad. Markeringen foljer klicket, inte fonstret.
    var start = Math.max(0, Math.min(vald, g.bilder.length - g.antal));
    var slut = start + g.antal;

    for (var i = 0; i < g.bilder.length; i++) {
      var inne = i >= start && i < slut;
      if (inne) g.bilder[i].removeAttribute('data-bz-dold');
      else g.bilder[i].setAttribute('data-bz-dold', '');
    }

    for (var j = 0; j < g.miniatyrer.length; j++) {
      var m = g.miniatyrer[j];
      var ar = j >= start && j < slut;
      m.setAttribute('aria-selected', j === vald ? 'true' : 'false');
      if (ar) m.setAttribute('data-bz-i-fonster', '');
      else m.removeAttribute('data-bz-i-fonster');
    }

    // Hall den valda miniatyren synlig - men bara nar raden faktiskt scrollar i
    // sidled. Annars kan scrollIntoView rycka hela sidan lodratt.
    var knapp = g.miniatyrer[vald];
    var behallare = knapp && knapp.closest('[data-bz-miniatyrer]');
    if (behallare && behallare.scrollWidth > behallare.clientWidth + 1) {
      var v = knapp.offsetLeft;
      var h = v + knapp.offsetWidth;
      if (v < behallare.scrollLeft) behallare.scrollLeft = v;
      else if (h > behallare.scrollLeft + behallare.clientWidth) {
        behallare.scrollLeft = h - behallare.clientWidth;
      }
    }
  }

  document.addEventListener('click', function (handelse) {
    var knapp = handelse.target.closest('[data-bz-till]');
    if (!knapp) return;
    if (!paDatorn()) return;

    var g = galleriFor(knapp);
    if (!g) return;

    handelse.preventDefault();
    visa(g, parseInt(knapp.getAttribute('data-bz-till'), 10) || 0);
  });

  // Nagot behov av att stada vid breddbyte finns inte: regeln som doljer
  // data-bz-dold ligger inne i @media (min-width: 750px), sa under den visas
  // bilderna igen av sig sjalva och karusellen far alla sina slides.
})();
